import  { post  }  from '../utils/request'
import config from '@/config/index'

//登陆
// export const mobileLogin = p => post(config.devProxy+'/mobile/cjpl/CjplClass/mobileLoginH5Ajax', p);
export const mobileLogin = p => post(config.devProxy+'/mobile/cjpl/CjplClass/mobileLoginAjax?type=8081', p);
//验证登录状态
export const checkLogin = p => post(config.devProxy+'/mobile/cjpl/CjplClass/checkLoginAjax', p);
//登陆错误超过5次锁定账户
export const getLockAjax = p => post(config.devProxy+'/rdbase/personManage/PersonManage/getLockAjax', p);
//账号管理
// export const modifyUserInfoAjax = p => post(config.devProxy+'/mobile/cjpl/CjplClass/modifyUserInfoAjax', p);
// export const getUserInfoAjax = p => post(config.devProxy+'/mobile/cjpl/CjplClass/getUserInfoAjax', p);
//价格采集  日报 周报 旬报 月报
// export const getCjpl = p => post(config.devProxy+'/mobile/cjpl/CjplClass/getCjpl', p);




//账号信息查询
export const getUserInfoAjax = p => post(config.devProxy+'/mobile/mobileTbAppBenUrls/getUserInfoCJDAjax', p);
//获取期号范围
export const getIssueRangeList= p => post(config.devProxy+'/mobile/mobileTbAppBenUrls/getIssueRangeList', p);
// 获取全部任务
export const getCollectionTask = p => post(config.devProxy+'/mobile/mobileTbAppBenUrls/getCollectionTask', p);
// 获取填报详情
export const dataGrid = p => post(config.devProxy+'/mobile/mobileTbAppBenUrls/dataGrid', p);
//保存填报信息
export const saveRow = p => post(config.devProxy+'/mobile/mobileTbAppBenUrls/saveRow', p);
//查看日志
export const getDateRecord= p => post(config.devProxy+'/mobile/mobileTbAppBenUrls/getDateRecord', p);
// 上报填报信息
export const upOK = p => post(config.devProxy+'/mobile/mobileTbAppBenUrls/upOk', p);

